import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const SectionStyled = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '0.75rem',
  padding: '1rem',

  [theme.breakpoints.up('md')]: {
    padding: '1.5rem'
  }
}));
